import { render, staticRenderFns } from "./ProjectTasksAndEstimatesTab.vue?vue&type=template&id=dcd90860"
import script from "./ProjectTasksAndEstimatesTab.vue?vue&type=script&lang=js"
export * from "./ProjectTasksAndEstimatesTab.vue?vue&type=script&lang=js"
import style0 from "./ProjectTasksAndEstimatesTab.vue?vue&type=style&index=0&id=dcd90860&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports